import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
const Textarea = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx("textarea", { className: cn("flex w-full rounded-xl border border-light-border dark:border-dark-border bg-light-elevated dark:bg-dark-elevated px-4 py-2.5 text-sm text-light-text dark:text-dark-text shadow-sm transition-colors placeholder:text-light-text-muted dark:placeholder:text-dark-text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500/50 focus-visible:border-purple-500 disabled:cursor-not-allowed disabled:opacity-50 min-h-[100px] resize-none", className), ref: ref, ...props }));
});
Textarea.displayName = "Textarea";
export { Textarea };
